import { JSX } from "preact";

interface FieldProps extends JSX.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  name?: string; // Explicitly allow name (used in htmlFor and input)
  type?: string; // Explicitly allow type (e.g., 'text', 'email')
  required?: boolean; // Explicitly allow required
}

export function Field(props: FieldProps) {
  return (
    <div class="field">
      {props.label && (
        <label htmlFor={`field-${props.name}`}>
          {props.label}
          {props.required && <span class="required-mark">*</span>}
        </label>
      )}
      <input
        type={props.type || "text"}
        id={`field-${props.name}`}
        autoComplete={props.autoComplete || "off"}
        {...props}
      />
    </div>
  );
}
